import styled from 'styled-components';
import { desktop_breakpoint_extended } from 'pubweb-smokey/dist/components/GridSystem/_vars_widths.js';
import Colors from 'pubweb-smokey/dist/colors';

export const TopFeaturesStyles = styled.div`
  .top-feature-title-section {
    display: flex;
    .top-features-title-heart {
      margin: 8px 8px 8px 0;
      svg {
        height: 20px;
        width: 20px;
      }
    }

    .top-features-title {
      font-size: 26px;
      letter-spacing: -0.35px;
      margin-bottom: 6px;
    }
    .top-features-subheading {
      margin-bottom: 12px;
      font-weight: 400;
      font-size: 15px;
      line-height: 21px;
      color: ${Colors.primary.claytonBlue.standard};
    }
  }

  .top-features-chevron {
    display: flex;
    justify-content: center;
    padding: 8px;
    svg {
      height: 16px;
      width: 16px;
    }
  }

  .features-list {
    list-style: none;
    margin-bottom: 12px;

    .features-list-item {
      font-size: 14px;
      height: 32px;
      line-height: 32px;
      margin: 8px 8px 0 0;
      padding: 0px 12px 0px 8px;
      border-radius: 2px;
      border-bottom: 1px solid #cacccf;
      cursor: pointer;

      svg {
        margin-right: 4px;
        position: relative;
        top: 3px;
      }
    }
  }
  .error-state {
    color: ${Colors.accent.barnDoor.standard};
    font-size: 14px;
  }

  @media screen and (min-width: ${desktop_breakpoint_extended}px) {
    .top-features-title {
      font-size: 25px;
    }
  }
`;

export default TopFeaturesStyles;
